<template>
  <div class="ui form" id="main">
    <div v-if="umu_manager">
      <h3>
        Отправлено {{umu_agreed_times}} раз
      </h3>
      <button class="ui button brown" v-on:click="MakePDF(prog)">
        <i class="file pdf outline icon"></i>
        Сформировать PDF
      </button>
    </div>
    <div v-if="department_manager">
      <h3>
        Отправлено {{department_agreed_times}} раз
      </h3>
    </div>
      <div id="basis">
          <div class="inline fields">
              <div class="five wide field">
                  <div class="ui right pointing large label">
                      РАБОЧАЯ ПРОГРАММА
                  </div>
                  <input type="text" placeholder="Дисциплина" v-model="main_info.discipline" disabled="true">
              </div>
              <div class="seven wide field" v-if="main_info.quality !== 'Специалитет'">
                  <div class="ui right pointing large label">
                      Направление подготовки
                  </div>
                  <input type="text" placeholder="Специальность" v-model="main_info.speciality" disabled="true">
              </div>
              <div class="seven wide field" v-if="main_info.quality === 'Специалитет'">
                  <div class="ui right pointing large label">
                      Специальность
                  </div>
                  <input type="text" placeholder="Специальность" v-model="main_info.speciality" disabled="true">
              </div>
              <div class="four wide field">
                  <div class="ui right pointing large label">
                      Квалификация выпускника
                  </div>
                  <input type="text" placeholder="Квалификация" v-model="main_info.quality" disabled="true">
              </div>
          </div>
          <div class="inline fields">
              <div class="seven wide field" v-if="main_info.quality !== 'Специалитет'">
                  <div class="ui right pointing large label">
                      Профиль
                  </div>
                  <input type="text" placeholder="Профиль" v-model="main_info.profile" disabled="true">
              </div>
              <div class="seven wide field" v-if="main_info.quality === 'Специалитет'">
                  <div class="ui right pointing large label">
                      Специализация
                  </div>
                  <input type="text" placeholder="Профиль" v-model="main_info.profile" disabled="true">
              </div>
              <div class="three wide field">
                  <div class="ui right pointing large label">
                      Год набора
                  </div>
                  <input type="text" placeholder="Год набора" v-model="main_info.year" disabled="true">
              </div>
              <div class="three wide field">
                  <div class="ui right pointing large label">
                      Форма обучения
                  </div>
                  <input type="text" placeholder="Форма обучения" v-model="main_info.edu_form" disabled="true">
              </div>
          </div>
          <div class="ui equal width form">
              <div class="inline fields">
                  <div class="inline fields" v-if="main_info.speciality_code.length !== 6 && main_info.speciality_code.length !== 7">
                      <div class="three wide field">
                          <div class="ui right pointing large label">
                              Курс
                          </div>
                          <input type="text" placeholder="Курс" v-model="main_info.course" disabled="true">
                      </div>
                      <div class="three wide field">
                          <div class="ui right pointing large label">
                              Семестр
                          </div>
                          <input type="text" placeholder="Семестр" v-model="main_info.period" disabled="true">
                      </div>
                  </div>
                  <div class="three wide field" v-else>
                      <div class="ui right pointing large label">
                          Год обучения
                      </div>
                      <input type="text" placeholder="Курс" v-model="main_info.period" disabled="true">
                  </div>
                  <div class="three wide field" v-if="main_info.credit.length">
                      <div class="ui right pointing large label">
                          Зачет
                      </div>
                      <input type="text" placeholder="Зачет" v-model="main_info.credit" disabled="true">
                  </div>
                  <div class="three wide field" v-if="main_info.credit_mark.length">
                      <div class="ui right pointing large label">
                          Зачет с оценкой
                      </div>
                      <input type="text" placeholder="Зачет" v-model="main_info.credit_mark" disabled="true">
                  </div>
                  <div class="three wide field" v-if="main_info.exam.length">
                      <div class="ui right pointing large label">
                          Экзамен
                      </div>
                      <input type="text" placeholder="Экзамен" v-model="main_info.exam" disabled="true">
                  </div>
              </div>
              <div v-if="main_info.speciality_code.split('.')[1] === '02'">
                  <div class="two fields">
                      <div class="seven wide field">
                          <div class="ui right pointing large label">
                            Вид дисциплины
                          </div>
                          <input type="text" placeholder="Вид дисциплины" v-model="main_info.discipline_type" disabled="true">
                      </div>
                      <div class="four wide field">
                          <div class="ui right pointing large label">
                            Индекс дисциплины
                          </div>
                          <input type="text" placeholder="Индекс" v-model="main_info.disciplines_index" disabled="true">
                      </div>
                  </div>
              </div>
              <div class="inline fields">
                  <div class="four wide field">
                      <div class="ui right pointing large label">
                        Трудоемкость
                      </div>
                      <input type="text" placeholder="Трудоемкость" v-model="main_info.load.hour" disabled="true">
                  </div>
                  <div class="three wide field">
                      <div class="ui right pointing large label">
                        ЗЕТ
                      </div>
                      <input type="text" placeholder="ЗЕТ" v-model="main_info.load.zet" disabled="true">
                  </div>
              </div>
              <div class="inline fields">
                  <div class="four wide field">
                      <div class="ui right pointing large label">
                          И.О.Фамилия
                      </div>
                      <input type="text" placeholder="И.О.Фамилия" v-model="initial" disabled="true">
                  </div>
                  <div class="four wide field">
                      <div class="ui right pointing large label">
                          Должность
                      </div>
                      <input type="text" placeholder="Должность" v-model="main_info.creator.position" disabled="true">
                  </div>
                  <div class="four wide field">
                      <div class="ui right pointing large label">
                          Ученая степень
                      </div>
                      <input type="text" placeholder="Ученая степень" v-model="main_info.creator.title" disabled="true">
                  </div>
              </div>
          </div>
          <div class="two fields">
              <div class="six wide field">
                  <label>Выпускающая кафедра</label>
                  <div class="ui input">
                      <input type="text" placeholder="Выпускающая кафедра" v-model="main_info.grad_dep" disabled="true">
                  </div>
              </div>
              <div class="six wide field">
                  <label>Заведующий выпускающей кафедры</label>
                  <div class="ui input">
                      <input type="text" placeholder="Заведующий выпускающей кафедры" v-model="main_info.provisor" disabled="true">
                  </div>
              </div>
          </div>
          <div class="inline fields">
              <div class="five wide field">
                  <div class="ui right pointing large label">
                      Факультет
                  </div>
                  <input type="text" placeholder="Факультет" v-model="main_info.facility" disabled="true">
              </div>
              <div class="five wide field">
                  <div class="ui right pointing large label">
                      Обеспечивающая Кафедра
                  </div>
                  <input type="text" placeholder="Обеспечивающая кафедра" v-model="main_info.department" disabled="true">
              </div>
              <div class="five wide field">
                  <div class="ui right pointing large label">
                      Заведующий кафедрой
                  </div>
                  <input type="text" placeholder="Заведующий кафедрой" v-model="main_info.dep_manager" disabled="true">
              </div>
          </div>
          <div class="two fields">
              <div class="four wide field">
                  <label>Дата заседания кафедры</label>
                  <div class="ui input">
                      <input type="text" placeholder="Дата заседания кафедры" v-model="main_info.approval_date" disabled="true">
                  </div>
              </div>
              <div class="two wide field">
                  <label>Протокол №</label>
                  <div class="ui input">
                      <input type="text" placeholder="Протокол №" v-model="main_info.protocol_num" disabled="true">
                  </div>
              </div>
          </div>
          <div><textarea rows="2" v-model="main_info.basis" disabled="true"></textarea></div>
          <div class="two fields">
              <div class="four wide field">
                  <label>Дата утверждения приказа</label>
                  <div class="ui input">
                      <input type="text" placeholder="Дата утверждения приказа" v-model="main_info.basis_date"  disabled="true">
                  </div>
              </div>
              <div class="two wide field">
                  <label>№ Приказа</label>
                  <div class="ui input">
                      <input type="text" placeholder="№ Приказа" v-model="main_info.basis_num" disabled="true">
                  </div>
              </div>
          </div>
      </div>
      <div id="1.Цели">
        <div v-if="main_info.speciality_code.split('.')[1] === '02'" >
          <h3 class="ui dividing header">1. ОБЛАСТЬ ПРИМЕНЕНИЯ ПРОГРАММЫ</h3>
          <h4>Рабочая программа {{main_info.discipline}} являетсяч частью ППССЗ в соотвествии с ФГОС по специальности {{main_info.speciality}}</h4>
          <h4>Дисциплина требует предварительного изучения</h4>
          <span v-html="text_info.purpose"></span>
          <h4>Дисциплина предшествует изучению (предназначена для создания теоретической базы знаний у студентов для изучения)</h4>
          <span v-html="text_info.task"></span>
        </div>
        <div v-else>
          <h3 class="ui dividing header">1. ЦЕЛИ И ЗАДАЧИ ОСВОЕНИЯ ДИСЦИПЛИНЫ</h3>
          <div>
            <h4>1.1 Цель дисциплины</h4>
            <span v-html="text_info.purpose"></span>
            <h4>1.2 Задачи дисциплины</h4>
            <span v-html="text_info.task"></span>
          </div>
        </div>
      </div>
      <div id="2.Место дисциплины">
          <h3 class="ui dividing header">2. МЕСТО ДИСЦИПЛИНЫ В СТРУКТУРЕ ОБРАЗОВАТЕЛЬНОЙ ПРОГРАММЫ</h3>
          <span v-if="main_info.speciality_code.split('.')[1] !== '02'" v-html="text_info.place"></span>
          <div v-if="main_info.speciality_code.split('.')[1] === '02'" >
            <h4>Из общего объема часов {{ (parseFloat(times["Практические занятия"].need) + parseFloat(times["Лабораторные занятия"].need)) }} часов являются практической подготовкой, которая представлена в программе в виде практических занятий</h4>
            <h4>Воспитание реализуется в программе в единстве урочной и внеурочной деятельности. В рамках каждого занятия планируются воспитательные цели, направленные на формирование профессионала в соответствии с квалификацией {{main_info.quality}} и воспитание соответствующих качеств личности.</h4>
            <h4>При планировании и проведении занятий планируются активные и интерактивные формы учебной деятельности:</h4>
            <ul>
              <li v-if="spo_comp.business">Деловые игры</li>
              <li v-if="spo_comp.role">Ролевые игры</li>
              <li v-if="spo_comp.situation">Разбор ситуаций</li>
              <li v-if="spo_comp.computer">Компьютерные симуляции</li>
            </ul>
            <h4>Дисциплина реализуется с использованием технологии электронного обучения. Дистанционные образовательные технологии могут быть использованы для всех видов занятий при необходимости (погодные условия, санитарноэпидемиологические требования, режим чрезвычайной ситуации, военные действия и т.д.)</h4>
          </div>
      </div>
      <div id="3. Компетенции">
          <h3 v-if="main_info.speciality_code.length !== 6 && main_info.speciality_code.length !== 7" class="ui dividing header">3. КОМПЕТЕНЦИИ ОБУЧАЮЩЕГОСЯ, ФОРМИРУЕМЫЕ В РЕЗУЛЬТАТЕ ОСВОЕНИЯ ДИСЦИПЛИНЫ (МОДУЛЯ) И ИНДИКАТОРЫ ИХ ДОСТИЖЕНИЯ</h3>
          <div v-if="main_info.speciality_code.split('.')[1] === '02'">
              <div v-if="main_info.discipline_type === 'Профессиональная дисциплина' || main_info.discipline_type === 'МДК' || main_info.discipline_type === 'Профессиональный модуль' || main_info.discipline_type === 'Учебная практика' || main_info.discipline_type === 'Производственная практика'">
                  <h4>3.1 Общие компетенции</h4>
                  <table class="ui basic celled table">
                      <thead>
                      <tr class="active">
                          <th width="20%"><div class="headTable">Код</div></th>
                          <th width="30%"><div class="headTable">Наименование общей компетенции</div></th>
                          <th width="50%"><div class="headTable">Наименование индикатора достижения общей компетенции</div></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for = "comp in rpd_competitions.UK">
                          <td> {{ comp.info.code }}</td>
                          <td>{{ comp.info.desc }}</td>
                          <td v-html="comp.text"></td>
                      </tr>
                      </tbody>
                  </table>
                  <h4>3.2 Професиональные компетенции и индикаторы их достижения</h4>
                  <table class="ui basic celled table" v-if="OPK.length">
                      <thead>
                      <tr class="active">
                          <th width="20%"><div class="headTable">Код</div></th>
                          <th width="30%"><div class="headTable">Наименование профессиональной компетенции</div></th>
                          <th width="50%"><div class="headTable">Наименование индикатора достижения профессиональной компетенции</div></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for = "comp in rpd_competitions.OPK_cat">
                          <td> {{ comp.info.code }}</td>
                          <td>{{ comp.info.desc }}</td>
                          <td v-html="comp.text"></td>
                      </tr>
                      </tbody>
                  </table>
                  <table class="ui basic celled table" v-if="!OPK.length">
                      <thead>
                      <tr class="active">
                          <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                          <th width="60%" colspan="2"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for = "comp in rpd_competitions.OPK">
                          <td>{{comp.name}}</td>
                          <td v-html="comp.text"></td>
                      </tr>
                      </tbody>
                  </table>
                  <h5 class="ui dividing header">Уметь </h5>
                  <span v-html="spo_comp.able"></span>
                  <h5 class="ui dividing header">Знать </h5>
                  <span v-html="spo_comp.know"></span>
                  <h5 v-if="main_info.discipline_type ==='МДК' || prog.main_info.discipline_type === 'Профессиональный модуль' || main_info.discipline_type === 'Учебная практика' || main_info.discipline_type === 'Производственная практика'" class="ui dividing header">Иметь практическое применение </h5>
                  <span v-if="main_info.discipline_type ==='МДК' || prog.main_info.discipline_type === 'Профессиональный модуль' || main_info.discipline_type === 'Учебная практика' || main_info.discipline_type === 'Производственная практика'" v-html="spo_comp.own"></span>
              </div>
              <div v-if="main_info.discipline_type === 'Общеобразовательная дисциплина'">
                  <span v-html="spo_comp.general"></span>
              </div>
          </div>
          <div v-else-if="main_info.speciality_code.length !== 6 && main_info.speciality_code.length !== 7" >
              <h4>3.1 Универсальные компетенции и индикаторы их достижения</h4>
              <table class="ui basic celled table">
                  <thead>
                  <tr class="active">
                      <th width="20%"><div class="headTable">Категория (группа) универсальных компетенций</div></th>
                      <th width="40%"><div class="headTable">Код и наименование универсальной компетенции</div></th>
                      <th width="40%"><div class="headTable">Код и наименование индикатора достижения универсальной компетенции</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "comp in rpd_competitions.UK">
                      <td>{{comp.info.cat}}</td>
                      <td>
                          {{ comp.info.code }} {{ comp.info.desc }}
                      </td>
                      <td v-html="comp.text"></td>
                  </tr>
                  </tbody>
              </table>
              <h4>3.2 Общепрофессиональные компетенции и индикаторы их достижения</h4>
              <table class="ui basic celled table" v-if="OPK.length">
                  <thead>
                  <tr class="active">
                      <th width="20%"><div class="headTable">Категория (группа) общепрофессиональных компетенций</div></th>
                      <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                      <th width="40%"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "comp in rpd_competitions.OPK_cat">
                      <td>{{comp.info.cat}}</td>
                      <td>
                          {{ comp.info.code }} {{ comp.info.desc }}
                      </td>
                      <td v-html="comp.text"></td>
                  </tr>
                  </tbody>
              </table>
              <table class="ui basic celled table" v-if="!OPK.length">
                  <thead>
                  <tr class="active">
                      <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                      <th width="60%"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "comp in rpd_competitions.OPK">
                      <td>{{comp.name}}</td>
                      <td v-html="comp.text"></td>
                  </tr>
                  </tbody>
              </table>
              <h4>3.3 Профессиональные компетенции и индикаторы их достижения</h4>
              <table class="ui basic celled table">
                  <thead>
                  <tr class="active">
                      <th width="40%"><div class="headTable">Код и наименование профессиональной компетенции</div></th>
                      <th width="60%"><div class="headTable">Код и наименование индикатора достижения профессиональной компетенции</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "comp in rpd_competitions.PK">
                      <td>{{comp.name}}</td>
                      <td v-html="comp.text"></td>
                  </tr>
                  </tbody>
              </table>
              <h4>3.4 Дополнительные профессиональные компетенции</h4>
              <table class="ui basic celled table">
                  <thead>
                  <tr class="active">
                      <th width="40%"><div class="headTable">Код и наименование дополнительной профессиональной компетенции</div></th>
                      <th width="60%"><div class="headTable">Код и наименование индикатора достижения дополнительной профессиональной компетенции</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "comp in rpd_competitions.DPK">
                      <td>{{comp.name}}</td>
                      <td v-html="comp.text"></td>
                  </tr>
                  </tbody>
              </table>
          </div>
      </div>
      <div id="4. Структура">
          <h3 class="ui dividing header">4. СТРУКТУРА ДИСЦИПЛИНЫ (МОДУЛЯ)</h3>
          <div v-if="main_info.speciality_code.split('.')[1] === '02'">
            Общая трудоемкость дисциплины составляет {{main_info.load.zet}} зачетных единиц, {{ main_info.load.hour}} академических часов
            <div class="ui basic segment" style="overflow-x: scroll;">
              <table class="ui basic celled table" cellpadding="0" cellspacing="0">
                <thead>
                <tr class="active">
                  <th rowspan="2" width="2%"><div class="headTable">№ п/п</div></th>
                  <th rowspan="2" width="20%"><div class="headTable">Тема (раздел) дисциплины, курсовая работа (проект), промежуточная аттестация</div></th>
                  <th rowspan="2" width="2%"><div class="verticalText">Семестр</div></th>
                  <th :colspan="8" width="18%"><div class="headTable">Виды контактной работы и трудоемкость (в академических часах)</div></th>
                  <th rowspan="2" width="5%"><div class="headTableInt">Экзамен</div></th>
                  <th rowspan="2" width="5%"><div class="headTableInt">Самостоятельная работа (в академических часах)</div></th>
                  <th rowspan="2" colspan="2" width="20%"><div class="headTable">Формы текущего контроля успеваемости</div></th>
                </tr>
                <tr>
                  <th width="3%"><div class="headTable">Л</div></th>
                  <th width="3%"><div class="headTable">ПЗ</div></th>
                  <th width="3%"><div class="headTable">ЛЗ</div></th>
                  <th width="3%"><div class="headTable">У</div></th>
                  <th width="3%"><div class="headTable">С</div></th>
                  <th width="3%" height="200px"><div class="verticalText">Курсовой проект/работа</div></th>
                  <th width="3%"><div class="verticalText">КТО</div></th>
                  <th width="3%"><div class="verticalText">Консультации</div></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for = "theme in o_themes">
                  <td>{{theme.num}}</td>
                  <td>{{theme.name}}</td>
                  <td>{{theme.period}}</td>
                  <td>{{theme.lecture}}</td>
                  <td>{{theme.practice}}</td>
                  <td>{{theme.laboratory}}</td>
                  <td>{{theme.lesson}}</td>
                  <td>{{theme.seminar}}</td>
                  <td>{{theme.ikr}}</td>
                  <td>{{theme.kto}}</td>
                  <td>{{theme.ke}}</td>
                  <td>{{theme.control}}</td>
                  <td>{{theme.indep_work}}</td>
                  <td>{{theme.control_form}}</td>
                </tr>
                <tr>
                  <td colspan="3"></td>
                  <td>{{o_lectureTime}}</td>
                  <td>{{o_practiceTime}}</td>
                  <td>{{o_laboratoryTime}}</td>
                  <td>{{o_lessonTime}}</td>
                  <td>{{o_seminarTime}}</td>
                  <td>{{o_ikrTime}}</td>
                  <td>{{o_ktoTime}}</td>
                  <td>{{o_keTime}}</td>
                  <td>{{o_controlTime}}</td>
                  <td>{{o_indepTime}}</td>
                  <td colspan="2"></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-else-if="main_info.speciality_code.length !== 6 && main_info.speciality_code.length !== 7">
              Общая трудоемкость дисциплины составляет {{main_info.load.zet}} зачетных единиц, {{ main_info.load.hour}} академических часов
              <div class="ui basic segment" style="overflow-x: scroll;">
                  <table class="ui basic celled table" cellpadding="0" cellspacing="0">
                      <thead>
                      <tr class="active">
                          <th rowspan="3" width="2%"><div class="headTable">№ п/п</div></th>
                          <th rowspan="3" width="20%"><div class="headTable">Тема (раздел) дисциплины, курсовая работа (проект), промежуточная аттестация</div></th>
                          <th rowspan="3" width="2%"><div class="verticalText">Семестр</div></th>
                          <th colspan="9" width="18%"><div class="headTable">Виды контактной работы и трудоемкость (в академических часах)</div></th>
                          <th rowspan="3" width="5%"><div class="headTableInt">Контроль (в академических часах)</div></th>
                          <th rowspan="3" width="5%"><div class="headTableInt">Самостоятельная работа (в академических часах)</div></th>
                          <th rowspan="3" width="30%"><div class="headTable">Формы текущего контроля успеваемости</div></th>
                      </tr>
                      <tr>
                          <th width="3%" colspan="2"><div class="headTable">Л</div></th>
                          <th width="3%" colspan="2"><div class="headTable">ПЗ</div></th>
                          <th width="3%" colspan="2"><div class="headTable">ЛР</div></th>
                          <th width="3%" rowspan="2"><div class="verticalText">ИКР</div></th>
                          <th width="3%" rowspan="2"><div class="verticalText">КТО</div></th>
                          <th width="3%" rowspan="2"><div class="verticalText">КЭ</div></th>
                      </tr>
                      <tr>
                          <th width="3%"><div class="verticalText">всего</div></th>
                          <th width="3%"><div class="verticalText">в виде ПП</div></th>
                          <th width="3%"><div class="verticalText">всего</div></th>
                          <th width="3%"><div class="verticalText">в виде ПП</div></th>
                          <th width="3%"><div class="verticalText">всего</div></th>
                          <th width="3%"><div class="verticalText">в виде ПП</div></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for = "theme in o_themes">
                          <td>{{theme.num}}</td>
                          <td>{{theme.name}}</td>
                          <td>{{theme.period}}</td>
                          <td>{{theme.lecture}}</td>
                          <td>{{theme.lecture_pp}}</td>
                          <td>{{theme.practice}}</td>
                          <td>{{theme.practice_pp}}</td>
                          <td>{{theme.laboratory}}</td>
                          <td>{{theme.laboratory_pp}}</td>
                          <td>{{theme.ikr}}</td>
                          <td>{{theme.kto}}</td>
                          <td>{{theme.ke}}</td>
                          <td>{{theme.control}}</td>
                          <td>{{theme.indep_work}}</td>
                          <td>{{theme.control_form}}</td>
                      </tr>
                      <tr>
                          <td colspan="3"></td>
                          <td colspan="2">{{o_lectureTime}}</td>
                          <td colspan="2">{{o_practiceTime}}</td>
                          <td colspan="2" >{{o_laboratoryTime}}</td>
                          <td>{{o_ikrTime}}</td>
                          <td>{{o_ktoTime}}</td>
                          <td>{{o_keTime}}</td>
                          <td>{{o_controlTime}}</td>
                          <td>{{o_indepTime}}</td>
                          <td colspan="2"></td>
                      </tr>
                      </tbody>
                  </table>
              </div>
          </div>
          <div v-else>
              Общая трудоемкость дисциплины составляет {{main_info.load.zet}} зачетных единиц, {{ main_info.load.hour}} академических часов
              <div class="ui basic segment" style="overflow-x: scroll;">
                  <table class="ui basic celled table" cellpadding="0" cellspacing="0">
                      <thead>
                      <tr class="active">
                          <th rowspan="2" width="2%"><div class="headTable">№ п/п</div></th>
                          <th rowspan="2" width="20%"><div class="headTable">Тема (раздел) дисциплины</div></th>
                          <th rowspan="2" width="5%"><div class="verticalText">Год обучения</div></th>
                          <th colspan="3" width="38%"><div class="headTable">Виды контактной работы, включая самостоятельную работу и трудоемкость (з.е)</div></th>
                          <th rowspan="2" width="30%"><div class="headTable">Формы текущего контроля успеваемости (по семестрам) Форма промежуточной аттестации (по семестрам)</div></th>
                      </tr>
                      <tr>
                          <th width="3%" ><div class="headTable">Л</div></th>
                          <th width="3%" ><div class="headTable">ПЗ</div></th>
                          <th width="3%" ><div class="headTable">СР</div></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for = "theme in o_themes">
                          <td width="2%"><div class="ui transparent input"><input @change="sortThemes" style="width:100%;" type="text" placeholder="Семестр" v-model="theme.num"></div></td>
                          <td>{{theme.name}}</td>
                          <td>{{ theme.period }}</td>
                          <td>{{ theme.lecture }}</td>
                          <td>{{ theme.practice }}</td>
                          <td>{{ theme.indep_work }}</td>
                          <td>{{ theme.control_form }}</td>
                      </tr>
                      <tr>
                          <td colspan="6"></td>
                          <td colspan="2" v-if="main_info.credit.length"> Зачет </td>
                          <td v-if="main_info.exam.length"> Экзамен - {{times.Экзамен.need}} </td>
                      </tr>
                      <tr>
                          <td colspan="3"></td>
                          <td > {{o_lectureTime}} </td>
                          <td> {{o_practiceTime}} </td>
                          <td> {{o_indepTime}} </td>
                          <td></td>
                      </tr>
                      </tbody>
                  </table>
              </div>
          </div>
      </div>
      <div id="5. Содержание (лекции, практики, лабы)">
          <h3 class="ui dividing header">5. СОДЕРЖАНИЕ ДИСЦИПЛИНЫ (МОДУЛЯ)</h3>
          <div>
            <h4>5.1 Лекции</h4>
            <table class="ui basic celled table">
                <thead>
                <tr class="active">
                    <th rowspan="2" width="5%"><div class="headTable">№ п/п</div></th>
                    <th rowspan="2" width="30%"><div class="headTable">Наименование темы (раздела)</div></th>
                    <th rowspan="2" width="65%"><div class="headTable">Содержание темы (раздела)</div></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for = "lec in o_lectures">
                    <td>{{o_lectures.indexOf(lec) + 1}}</td>
                    <td>{{lec.name}}</td>
                    <td v-html="lec.lec_content_old"></td>
                </tr>
                </tbody>
            </table>
            <h4>5.2 Практические занятия</h4>
            <table class="ui basic celled table">
                <thead>
                <tr class="active">
                    <th rowspan="2" width="5%"><div class="headTable">№ п/п</div></th>
                    <th rowspan="2" width="30%"><div class="headTable">Наименование темы (раздела)</div></th>
                    <th rowspan="2" width="65%"><div class="headTable">Содержание темы (раздела)</div></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for = "prac in o_practice">
                    <td colspan="3">
                        <table class="ui basic celled table">
                            <thead>
                            <tr class="active">
                                <th colspan="3" width="5%">{{prac.practice_name}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for = "work in prac.practice_work">
                                <td width="30%">{{work.work_name}}</td>
                                <td width="70%" v-html="work.content"></td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
            <h4>5.3 Лабораторные работы</h4>
            <table class="ui basic celled table">
                <thead>
                <tr class="active">
                    <th rowspan="2" width="5%"><div class="headTable">№ п/п</div></th>
                    <th rowspan="2" width="30%"><div class="headTable">Наименование темы (раздела)</div></th>
                    <th rowspan="2" width="65%"><div class="headTable">Содержание темы (раздела)</div></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for = "prac in o_laboratory">
                    <td colspan="3">
                        <table class="ui basic celled table">
                            <thead>
                            <tr class="active">
                                <th colspan="3" width="5%">{{prac.laboratory_name}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for = "work in prac.laboratory_work">
                                <td width="30%">{{work.work_name}}</td>
                                <td width="70%" v-html="work.content"></td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
            <div v-if="main_info.speciality_code.split('.')[1] === '02'">
              <h4>5.4 Уроки</h4>
              <table class="ui basic celled table">
                <thead>
                <tr class="active">
                  <th rowspan="2" width="5%"><div class="headTable">№ п/п</div></th>
                  <th rowspan="2" width="30%"><div class="headTable">Наименование темы (раздела)</div></th>
                  <th rowspan="2" width="65%"><div class="headTable">Содержание темы (раздела)</div></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for = "les in o_lesson">
                  <td>{{o_lesson.indexOf(les) + 1}}</td>
                  <td>{{les.name}}</td>
                  <td v-html="les.les_content_old"></td>
                </tr>
                </tbody>
              </table>
              <h4>5.5 Семинарские занятия</h4>
              <table class="ui basic celled table">
                <thead>
                <tr class="active">
                  <th rowspan="2" width="5%"><div class="headTable">№ п/п</div></th>
                  <th rowspan="2" width="30%"><div class="headTable">Наименование темы (раздела)</div></th>
                  <th rowspan="2" width="65%"><div class="headTable">Содержание темы (раздела)</div></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for = "sem in o_seminar">
                  <td>{{o_seminar.indexOf(sem) + 1}}</td>
                  <td>{{sem.name}}</td>
                  <td v-html="sem.sem_content_old"></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
      </div>
      <div id="6. Самостоятельные">
          <h3 class="ui dividing header">6. САМОСТОЯТЕЛЬНАЯ РАБОТА</h3>
          <table class="ui basic celled table">
              <thead>
              <tr class="active">
                  <th rowspan="2" width="5%"><div class="headTable">№ п/п</div></th>
                  <th rowspan="2" width="20%"><div class="headTable">Наименование темы (раздела)</div></th>
                  <th rowspan="2" width="65%"><div class="headTable">Форма (вид) самостоятельной работы</div></th>
                  <th rowspan="2" width="10%"><div class="headTable">Трудоемкость в академических часах</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "work in o_indepWork">
                  <td>{{o_indepWork.indexOf(work) + 1}}</td>
                  <td>{{work.indep_work_name}}</td>
                  <td v-html="work.indep_content_old"></td>
                  <td>{{work.indep_work}}</td>
              </tr>
              </tbody>
          </table>
      </div>
      <div id="7. Образовательные технологии" v-if="main_info.speciality_code.split('.')[1] !== '02'">
          <h3 class="ui dividing header">7. ОБРАЗОВАТЕЛЬНЫЕ ТЕХНОЛОГИИ</h3>
          <span v-html="text_info.technology"></span>
<!--          <table class="ui basic celled table" v-if="main_info.speciality_code.split('.')[1] === '02'">-->
<!--              <thead>-->
<!--              <tr class="active">-->
<!--                  <th width="28%"><div class="headTable">Формы/Методы</div></th>-->
<!--                  <th width="40%"><div class="headTable">лекционные занятия</div></th>-->
<!--                  <th width="42%"><div class="headTable">практические/лабораторные/семинарские занятия</div></th>-->
<!--              </tr>-->
<!--              </thead>-->
<!--              <tbody>-->
<!--              <tr v-for = "form in forms">-->
<!--                  <td>{{ form.name }}</td>-->
<!--                  <td>{{ form.lec }}</td>-->
<!--                  <td>{{ form.prac }}</td>-->
<!--              </tr>-->
<!--              </tbody>-->
<!--          </table>-->
      </div>
      <div id="8. Оценочные средства">
          <h3 class="ui dividing header">8. ОЦЕНОЧНЫЕ СРЕДСТВА ДЛЯ ПРОМЕЖУТОЧНОЙ АТТЕСТАЦИИ</h3>
          <table class="ui basic celled table" v-if="main_info.speciality_code.split('.')[1] === '02' && (main_info.discipline_type === 'Профессиональная дисциплина' || main_info.discipline_type === 'МДК' || main_info.discipline_type === 'Профессиональный модуль' || main_info.discipline_type === 'Учебная практика' || main_info.discipline_type === 'Производственная практика')">
              <thead>
              <tr class="active">
                  <th width="40%"><div class="headTable">Результаты (освоенные профессиональные компетенции)</div></th>
                  <th width="60%"><div class="headTable">Формы и методы контроля и оценки</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "option in rpd_competitions.UK">
                  <td>{{ option.info.code }} {{ option.info.desc }}</td>
                  <td>{{ option.control }}</td>
              </tr>
              <tr v-for = "option in rpd_competitions.OPK_cat">
                  <td>{{ option.info.code }} {{ option.info.desc }}</td>
                  <td>{{ option.control }}</td>
              </tr>
              </tbody>
          </table>
          <table class="ui basic celled table" v-else-if="main_info.speciality_code.split('.')[1] === '02' && main_info.discipline_type === 'Общеобразовательная дисциплина'">
              <thead>
              <tr class="active">
                  <th width="60%"><div class="headTable">Результаты (освоенные профессиональные компетенции)</div></th>
                  <th width="40%" colspan="2"><div class="headTable">Формы и методы контроля и оценки</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "control in spo_controls">
                  <td>{{ control.name }}</td>
                  <td>{{ control.lec }}</td>
              </tr>
              </tbody>
          </table>
          <span v-html="text_info.eval_tool"></span>
      </div>
      <div id="9. Учебно-методическое обеспечение">
          <h3 class="ui dividing header">9. УЧЕБНО-МЕТОДИЧЕСКОЕ И ИНФОРМАЦИОННОЕ ОБЕСПЕЧЕНИЕ</h3>
          <div>
              <h4>9.a) литература</h4>
              <span v-html="text_info.literature"></span>
              <h4>9.б) программное обеспечение и Интернет ресурсы</h4>
              <table class="ui basic celled table">
                  <thead>
                  <tr class="active">
                      <th width="20%"><div class="headTable">Наименование</div></th>
                      <th width="40%"><div class="headTable">Описание</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "soft in software">
                      <td>
                          {{soft.info.name}}
                      </td>
                      <td>
                          {{ soft.info.license }}
                      </td>
                  </tr>
                  <tr v-for = "res in resources">
                      <td>{{res.name}}</td>
                      <td>{{res.desc}}</td>
                  </tr>
                  </tbody>
              </table>
              <h4>9.в) профессиональные базы данных и информационные справочные системы</h4>
              <table class="ui basic celled table">
                  <thead>
                  <tr class="active">
                      <th width="20%"><div class="headTable">Наименование</div></th>
                      <th width="40%"><div class="headTable">Описание</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "db in data_bases">
                      <td>{{db.name}}</td>
                      <td>{{db.desc}}</td>
                  </tr>
                  </tbody>
              </table>
          </div>
      </div>
      <div id="10. МТО">
          <h3 class="ui dividing header">10. МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ ДИСЦИПЛИНЫ</h3>
          <span v-html="text_info.mto"></span>
      </div>
      <div v-if="has_z_part">
          <h3 class="ui dividing header">ПРИЛОЖЕНИЕ К РАБОЧЕЙ ПРОГРАММЕ</h3>
          <p>В соответствии с учебным планом для заочной формы обучения предусмотрено</p>
          <p v-if="z_control.used">Экзамен {{z_control.period.join()}} сем, {{z_control.input}} акад. часа</p>
          <p v-if="z_times.Зачет.used">Зачет {{z_times.Зачет.period.join()}} сем, {{z_times.Зачет.input}} акад. часа</p>
          <p v-if="z_times['Зачет с оценкой'].used">Зачет с оценкой {{z_times['Зачет с оценкой'].period.join()}} сем, {{z_times['Зачет с оценкой'].input}} акад. часа</p>
          <p v-if="z_lectureTime !== 0">Лекции {{z_lectureTime}} акад. часа</p>
          <p v-if="z_practiceTime !== 0">Практические занятия {{z_practiceTime}} акад. часа</p>
          <p v-if="z_laboratoryTime !== 0">Лабораторные работы{{z_laboratoryTime}} акад. часа</p>
          <p v-if="z_ikrTime !== 0">ИКР {{z_ikrTime}} акад. часа</p>
          <p v-if="z_indepTime !== 0">Самостоятельная работа {{z_indepTime}} акад. часа</p>
          <p>Общая трудоемкость дисциплины составляет {{main_info.load.zet}} зачетных единиц, {{ main_info.load.hour}} академических часов</p>
          <h4>СТРУКТУРА ДИСЦИПЛИНЫ</h4>
          <div class="ui basic segment" style="overflow-x: scroll;">
              <table class="ui basic celled table" cellpadding="0" cellspacing="0">
                  <thead>
                  <tr class="active">
                      <th rowspan="3" width="2%"><div class="headTable">№ п/п</div></th>
                      <th rowspan="3" width="20%"><div class="headTable">Тема (раздел) дисциплины, курсовая работа (проект), промежуточная аттестация</div></th>
                      <th rowspan="3" width="2%"><div class="verticalText">Семестр</div></th>
                      <th colspan="9" width="18%"><div class="headTable">Виды контактной работы и трудоемкость (в академических часах)</div></th>
                      <th rowspan="3" width="5%"><div class="headTableInt">Контроль (в академических часах)</div></th>
                      <th rowspan="3" width="5%"><div class="headTableInt">Самостоятельная работа (в академических часах)</div></th>
                      <th rowspan="3" width="30%"><div class="headTable">Формы текущего контроля успеваемости</div></th>
                  </tr>
                  <tr>
                      <th width="3%" colspan="2"><div class="headTable">Л</div></th>
                      <th width="3%" colspan="2"><div class="headTable">ПЗ</div></th>
                      <th width="3%" colspan="2"><div class="headTable">ЛР</div></th>
                      <th width="3%" rowspan="2"><div class="verticalText">ИКР</div></th>
                      <th width="3%" rowspan="2"><div class="verticalText">КТО</div></th>
                      <th width="3%" rowspan="2"><div class="verticalText">КЭ</div></th>
                  </tr>
                  <tr>
                      <th width="3%"><div class="verticalText">всего</div></th>
                      <th width="3%"><div class="verticalText">в виде ПП</div></th>
                      <th width="3%"><div class="verticalText">всего</div></th>
                      <th width="3%"><div class="verticalText">в виде ПП</div></th>
                      <th width="3%"><div class="verticalText">всего</div></th>
                      <th width="3%"><div class="verticalText">в виде ПП</div></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for = "theme in z_themes">
                      <td>{{theme.num}}</td>
                      <td>{{theme.name}}</td>
                      <td>{{theme.period}}</td>
                      <td>{{theme.lecture}}</td>
                      <td>{{theme.lecture_pp}}</td>
                      <td>{{theme.practice}}</td>
                      <td>{{theme.practice_pp}}</td>
                      <td>{{theme.laboratory}}</td>
                      <td>{{theme.laboratory_pp}}</td>
                      <td>{{theme.ikr}}</td>
                      <td>{{theme.kto}}</td>
                      <td>{{theme.ke}}</td>
                      <td>{{theme.control}}</td>
                      <td>{{theme.indep_work}}</td>
                      <td>{{theme.control_form}}</td>
                  </tr>
                  <tr>
                      <td colspan="3"></td>
                      <td colspan="2">{{z_lectureTime}}</td>
                      <td colspan="2">{{z_practiceTime}}</td>
                      <td colspan="2" >{{z_laboratoryTime}}</td>
                      <td>{{z_ikrTime}}</td>
                      <td>{{z_ktoTime}}</td>
                      <td>{{z_keTime}}</td>
                      <td>{{z_controlTime}}</td>
                      <td>{{z_indepTime}}</td>
                      <td colspan="2"></td>
                  </tr>
                  </tbody>
              </table>
          </div>
          <h4>САМОСТОЯТЕЛЬНАЯ РАБОТА</h4>
          <table class="ui basic celled table">
              <thead>
              <tr class="active">
                  <th rowspan="2" width="5%"><div class="headTable">№ п/п</div></th>
                  <th rowspan="2" width="20%"><div class="headTable">Наименование темы (раздела)</div></th>
                  <th rowspan="2" width="65%"><div class="headTable">Форма (вид) самостоятельной работы</div></th>
                  <th rowspan="2" width="10%"><div class="headTable">Трудоемкость в академических часах</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "work in z_indepWork">
                  <td>{{z_indepWork.indexOf(work) + 1}}</td>
                  <td>{{ work.indep_work_name }}</td>
                  <td v-html="work.indep_content_old"></td>
                  <td>{{work.indep_work}}</td>
              </tr>
              </tbody>
          </table>
      </div>
      <div v-if="umu_manager">
        Согласование уму
          <button class="ui button negative" v-on:click="denyRPDUMU(rpd_id, umu_agreed_times, umu_comment)">
              Отклонить
          </button>
          <button class="ui right floated button positive" v-on:click="agreedRPDUMU(rpd_id)">
              Согласовать
          </button>
      </div>
      <div v-if="department_manager">
        Согласование Кафедра
          <button class="ui button negative" v-on:click="denyRPDDepartment(rpd_id, department_agreed_times, department_comment)">
              Отклонить
          </button>
          <button class="ui right floated button positive" v-on:click="agreedRPDDepartment(rpd_id)">
              Согласовать
          </button>
      </div>
      <div class="ui modal" id="deny_umu_modal">
          <div class="ui header">Отклонить?</div>
          <div class="content">
              <div class="ui form">
                  <div class="field">
                      <label>Оставить отзыв (опционально)</label>
                      <textarea v-model="deny_text"></textarea>
                  </div>
              </div>
          </div>
          <div class="actions">
              <div class="ui gray deny button">
                  Закрыть
              </div>
              <div class="ui positive inverted right labeled icon button">
                  Подтвердить
                  <i class="checkmark icon"></i>
              </div>
          </div>
      </div>
      <div class="ui modal" id="error_umu_modal">
          <div class="ui header">Произошла ошибка</div>
          <div class="content">
              <div class="ui form">
                  <div class="field">
                      <label v-model="error_message_text"></label>
                  </div>
              </div>
          </div>
          <div class="actions">
              <div class="ui gray deny button">
                  Закрыть
              </div>
              <div class="ui positive inverted right labeled icon button">
                  Подтвердить
                  <i class="checkmark icon"></i>
              </div>
          </div>
      </div>
  </div>

</template>

<script>
import axios from "axios";
import htmlToText from "html-to-text";
import competitionsMixin from "../mixins/competitionsMixin";
import dataMixin from "../mixins/dataMixin";
import dataRpdMixin from "../mixins/dataRpdMixin";
import computedMixin from "../mixins/computedMixin";
import getersMixin from "../mixins/getersMixin";
import StructSPO from "../components/struct_spo.vue";
import rpd_pdf from "../../../../makepdfs/programms/rpd_pdf";
import rpd_supplement_pdf from "../../../../makepdfs/programms/rpd_supplement_pdf";
import rpd_anotation_pdf from "../../../../makepdfs/programms/rpd_anotation_pdf";

export default {
  name: "show_rpd",
  mixins: [competitionsMixin, dataMixin, dataRpdMixin, computedMixin, getersMixin],
  components: { StructSPO },
  data: () => ({
    deny_text: "",
    umu_agreed_times: 1,
    umu_manager: false,
    umu_comment: "",
    department_agreed_times: 1,
    department_manager: false,
    department_comment: "",
    error_message_text: "",
    prog: {},
  }),
  computed: {
  },
  methods: {
    getRPD(id) {
      axios({
        method: 'get',
        url: `/programms/get_rpd/${id}`,
      }).then((response) => {
        this.rpd_competitions = response.data.rpd.competition;
        this.text_info.purpose = response.data.rpd.purpose_old;
        this.text_info.task = response.data.rpd.tasks_old;
        this.text_info.place = response.data.rpd.discipline_place_old;
        this.text_info.technology = response.data.rpd.edu_tech_old;
        this.text_info.eval_tool = response.data.rpd.eval_tool_old;
        this.text_info.literature = response.data.rpd.literature_old;
        this.text_info.mto = response.data.rpd.structure_text_old;
        this.software = response.data.rpd.software;
        this.resources = response.data.rpd.resources;
        this.data_bases = response.data.rpd.data_bases;
        this.main_info = response.data.rpd.main_info;
        this.spo_comp = response.data.rpd.spo_comp;
        this.spo_controls = response.data.rpd.spo_controls;
        this.forms = response.data.rpd.forms;
        this.curriculum_id = response.data.rpd.curriculum_id;
        this.discipline_id = response.data.rpd.discipline_id;
        this.rpd_sample = response.data.rpd.rpd_sample;
        this.library_agreed = response.data.rpd.library_agreed;
        this.software_agreed = response.data.rpd.software_agreed;
        this.umu_agreed = response.data.rpd.umu_agreed;
        this.has_z_part = response.data.rpd.has_z_part;
        this.department_agreed = response.data.rpd.department_agreed;
        this.umu_agreed_times = response.data.rpd.umu_agreed_times;
        this.umu_comment = response.data.rpd.umu_comment;
        this.department_agreed_times = response.data.rpd.department_agreed_times;
        this.department_comment = response.data.rpd.department_comment;
        this.getProg()
        this.getGraduatedDep(this.curriculum_id)
        this.getOverload(this.curriculum_id, this.discipline_id)
      }).catch((error) => {
        return error;
      });
    },
    getThemes(id){
      axios({
        method: 'get',
        url: `/programms/get_themes/${id}`,
      }).then((response) => {
        this.themes = response.data.themes;
        this.sortThemes()
      }).catch((error) => {
        return error;
      });
    },
    getProg(){
      this.prog = { purpose_old: this.text_info.purpose,
        tasks_old: this.text_info.task,
        discipline_place_old: this.text_info.place,
        structure_text_old: this.text_info.mto,
        edu_tech_old: this.text_info.technology,
        eval_tool_old: this.text_info.eval_tool,
        literature_old: this.text_info.literature,
        competition: this.rpd_competitions,
        software: this.software,
        resources: this.resources,
        data_bases: this.data_bases,
        main_info: this.main_info,
        rpd_sample: this.rpd_sample,
        has_z_part: this.has_z_part,
        name: this.main_info.discipline,
        spo_comp: this.spo_comp,
        spo_controls: this.spo_controls,
        forms: this.forms,
      }
      console.log(this.prog.main_info)
    },
    sortThemes(){
      this.themes.sort(function(a, b) {
        return a.num - b.num;
      });
    },
    denyRPDUMU(id, times, text){
      this.deny_text = text;
      $('#deny_umu_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpd/' + id,
            data: {
              data: {
                umu_agreed: false,
                umu_comment: this.deny_text,
                umu_agreed_times: times + 1,
                considered: false,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204){
              this.nextToAgreed()
            } else {
              $('#error_umu_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_umu_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPDUMU(id){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpd/' + id,
        data: {
          data: {
            umu_agreed: true,
          }
        }
      }).then((response) => {
        if(response.status == 200 || response.status == 204){
          this.nextToAgreed()
        } else {
          $('#error_umu_modal').modal({
            closable: false,
            autofocus: false,
            onDeny: () => {
            },
            onApprove: () => {
            }
          }).modal('show');
        }
      }).catch((error) => {
        this.error_message_text = error.response.data,
            $('#error_umu_modal').modal({
              closable: false,
              autofocus: false,
              onDeny: () => {
              },
              onApprove: () => {
              }
            }).modal('show');
        return error;
      });
    },
    denyRPDDepartment(id, times, text){
      this.deny_text = text;
      $('#deny_umu_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpd/' + id,
            data: {
              data: {
                department_agreed: false,
                department_comment: this.deny_text,
                department_agreed_times: times + 1,
                considered: false,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204){
              location.assign('/programms/rpd')
            } else {
              $('#error_umu_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_umu_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPDDepartment(id){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpd/' + id,
        data: {
          data: {
            department_agreed: true,
          }
        }
      }).then((response) => {
        if(response.status == 200 || response.status == 204){
          location.assign('/programms/rpd')
        } else {
          $('#error_umu_modal').modal({
            closable: false,
            autofocus: false,
            onDeny: () => {
            },
            onApprove: () => {
            }
          }).modal('show');
        }
      }).catch((error) => {
        this.error_message_text = error.response.data,
            $('#error_umu_modal').modal({
              closable: false,
              autofocus: false,
              onDeny: () => {
              },
              onApprove: () => {
              }
            }).modal('show');
        return error;
      });
    },
    umuManager(){
      axios({
        method: 'get',
        url: `/programms/umu_manager`,
      }).then((response) => {
        this.umu_manager = response.data.umu;
      }).catch((error) => {
        return error;
      });
    },
    departmentManager(){
      axios({
        method: 'get',
        url: `/programms/department_manager`,
      }).then((response) => {
        this.department_manager = response.data.umu;
      }).catch((error) => {
        return error;
      });
    },
    nextToAgreed(){
      let url = `/programms/first_to_agreed_vo`
      if (this.main_info.speciality_code.split('.')[1] === '02'){
        url = `/programms/first_to_agreed_spo`
      }
      if (this.main_info.speciality_code.length === 6 || this.main_info.speciality_code.length === 7){
        url = `/programms/first_to_agreed_asp`
      }
      axios({
        method: 'get',
        url: url,
      }).then((response) => {
        location.assign(`/programms/rpd/${response.data.id}`)
      }).catch((error) => {
        return error;
      });
    },
    MakePDF(prog){
      rpd_pdf.MakePDF(prog, this.spo_control, this.spo_times, this.o_lectureTime, this.o_practiceTime, this.o_laboratoryTime, this.o_ikrTime,
          this.o_ktoTime, this.o_keTime, this.o_lessonTime, this.o_seminarTime, this.o_controlTime, this.o_indepTime, this.o_lectures, this.o_lesson,
          this.o_seminar, this.o_practice, this.o_laboratory, this.o_indepWork, this.z_control, this.z_times, this.z_lectureTime, this.z_practiceTime,
          this.z_laboratoryTime, this.z_ikrTime, this.z_ktoTime, this.z_keTime, this.z_controlTime, this.z_indepTime, this.z_indepWork, this.o_themes, this.z_themes)
    },
  },
  mounted() {
    this.rpd_id = window.location.pathname.split('/')[3]
    this.getRPD(this.rpd_id)
    this.getThemes(this.rpd_id)
    this.umuManager()
    this.departmentManager()
  }

}
</script>

<style scoped>

  .verticalText
  {
    text-align: center;
    vertical-align: middle;
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    line-height: 1;
    width: 20px;
  }

  .headTable
  {
    text-align: center;
    vertical-align: top;
    overflow-wrap: break-word;
  }

  .headTableInt
  {
    text-align: center;
    vertical-align: top;
    overflow-wrap: break-word;
    word-wrap: break-word;
    width: 70px;
  }
</style>